import React from 'react'


interface TProps {
    message: string | undefined;
}

const SwalHtmlComponent = (props: TProps) => {
    return (
        <>
            <div className='text-start swal-color'>
                {props?.message}
            </div>
        </>
    )
}

export default SwalHtmlComponent 